import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { staffName } from '../utils/format';
import './Login.css';

function ForcePasswordChange({ user, onDone, onLogout }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPasswords, setShowPasswords] = useState(false);

  const inputType = showPasswords ? 'text' : 'password';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.');
      return;
    }
    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }

    setLoading(true);
    try {
      await authAPI.changeMyPassword(currentPassword, newPassword);
      onDone();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to change password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Wylie Recruit</h1>
        <h2>Set your password</h2>
        {user && (
          <p className="force-pw-account">
            Setting a new password for
            {user.full_name ? ` ${staffName(user.full_name)} · ` : ' '}
            <strong>{user.email}</strong>
          </p>
        )}
        <p className="force-pw-hint">
          Your account is using a temporary password. Please choose your own
          password before continuing.
        </p>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="currentPassword">Temporary password</label>
            <input
              type={inputType}
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="newPassword">New password (min 8 characters)</label>
            <input
              type={inputType}
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              minLength={8}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm new password</label>
            <input
              type={inputType}
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              minLength={8}
              required
              disabled={loading}
            />
          </div>
          <label className="show-password-toggle">
            <input
              type="checkbox"
              checked={showPasswords}
              onChange={(e) => setShowPasswords(e.target.checked)}
              disabled={loading}
            />
            Show passwords
          </label>
          <button type="submit" disabled={loading}>
            {loading ? 'Saving…' : 'Save password'}
          </button>
        </form>
        <button
          type="button"
          className="force-pw-logout"
          onClick={onLogout}
          disabled={loading}
        >
          Log out
        </button>
      </div>
    </div>
  );
}

export default ForcePasswordChange;
